import { Dimensions, StyleSheet } from 'react-native';
import theme from '@/config/theme';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  card: { marginHorizontal: 4 },
  controlWrapper: {
    flexDirection: 'row',
    marginTop: 16,
    marginBottom: 4,
    justifyContent: 'center',
  },
  setTitleContainer: { padding: 8 },
  setTitle: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '600',
  },
  userImg: {
    width: 30,
    height: 30,
    borderRadius: 60,
    marginRight: 10,
  },
  userBox: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: 10,
  },
  modalAll: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },

  greyBackground: {
    flex: 1,
    backgroundColor: '#00000099',
    position: 'absolute',
    width: Dimensions.get('screen').width,
    height: Dimensions.get('screen').height,
  },
  underline: {
    backgroundColor: colors.grey,
    width: '100%',
    height: 1,
  },
  maxWidth: {
    backgroundColor: colors.white,
    flex: 1,
    maxWidth: 1000,
    maxHeight: '90%',
  },
  titleOne: {
    textAlign: 'center',
    fontWeight: '500',
    color: colors.darkGrey,
    paddingVertical: 15,
  },
  titleTwo: {
    textAlign: 'center',
    fontSize: 18,
    fontWeight: '600',
    paddingVertical: 15,
  },
  containerButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 10,
    gap: 10,
  },
  button: {
    padding: 10,
    flex: 1,
    borderRadius: 4,
  },
  buttonText: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
  },
  listItem: {
    margin: 5,
    flex: 1 / 3,
  },
  textStyle: {
    fontSize: 16,
    paddingVertical: 15,
    paddingHorizontal: 25,
  },

  ellipsisBtn: {
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.lg,
    backgroundColor: theme.colors.white,
  },
  menuWrapper: {
    position: 'absolute',
    zIndex: 100,
    borderRadius: theme.borderRadii.lg,
    backgroundColor: theme.colors.white,
  },
  menuButtonWrapper: {
    borderColor: colors.newUI.therapist.brandGreen,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadii.lg,
    minWidth: 250,
    elevation: 5,
    shadowColor: colors.newUI.therapist.shadow,
    shadowOffset: { width: -11, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 26,
  },
  btnWithIcon: {
    flex: 1,
    justifyContent: 'center',
    padding: theme.spacings.sm,
  },
  btnWithoutIcon: {
    flex: 1,
    justifyContent: 'center',
    minWidth: 0,
  },
});
